import { http } from '@/core/helpers/http.helper';
import { Activity } from '@/core/collections/activities/activity.interface';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { HIT_INCLUDES } from '../hits/hit.service';
import { COMMUNICATION_INCLUDES } from '../communications/communication.service';

class ACTIVITY_INCLUDES_CLASS {
   all: Record<'includes' | 'appends', Array<string>> = {
      includes: [
         'user',
         'team',
         'candidate',
         'position',
         'customer',
         'target',
         ...HIT_INCLUDES.activity.includes.map((i) => `target.${i}`),
         ...COMMUNICATION_INCLUDES.activity.includes.map((i) => `target.${i}`),
      ],
      appends: [],
   };
}

export const ACTIVITY_INCLUDES = new ACTIVITY_INCLUDES_CLASS();

export class ActivityService {
   async getFilteredCandidateActivities(syncId: string, query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Activity>>>(`/nxt-candidates/${syncId}/activities`, {
         params: { ...query },
      });
      return response.data;
   }

   async getFilteredCustomerActivities(syncId: string, query: LocationQuery) {
      const response = await http.get<ApiResource<Array<Activity>>>(`/nxt-customers/${syncId}/activities`, {
         params: { ...query },
      });
      return response.data;
   }

   async getActivities() {
      throw Error('Method not implemented');
   }

   async getActivity() {
      throw Error('Method not implemented');
   }

   async postActivity() {
      throw Error('Method not implemented');
   }

   async putActivity(id: number, is_pinned: Activity['is_pinned']) {
      const response = await http.put<ApiResource<Activity>>(`/activities/${id}`, { is_pinned });
      return response.data;
   }

   async deleteActivity() {
      throw Error('Method not implemented');
   }
}
